import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  search: '',
  type: '',
};

// create slice
const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    changeType: (state, action) => {
      state.type = action.payload;
    },
    search: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state, action) => {
      state.search = '';
      state.type = '';
    },
  },
});

export default filterSlice.reducer;
export const { search, changeType, clearFilter } = filterSlice.actions;
